import './node-plugins-table.style.scss'

class nodePluginsTableController {

}

export default nodePluginsTableController;



// WEBPACK FOOTER //
// ./ui/src/components/node-plugins-table/node-plugins-table.controller.js